var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#defaultAvatar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M6.125 9.563a1.286 1.286 0 1 0 2.571 0 1.286 1.286 0 0 0-2.571 0m9.429 0a1.286 1.286 0 1 0 2.57 0 1.286 1.286 0 0 0-2.57 0M12.125 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12m7.045 19.045A10 10 0 0 1 16 21.182a9.9 9.9 0 0 1-3.875.782 9.92 9.92 0 0 1-7.047-2.92A9.91 9.91 0 0 1 2.16 12a9.921 9.921 0 0 1 2.92-7.047 9.91 9.91 0 0 1 7.045-2.917 9.921 9.921 0 0 1 7.047 2.92A9.909 9.909 0 0 1 22.09 12a9.9 9.9 0 0 1-.783 3.879 9.9 9.9 0 0 1-2.137 3.166m-2.974-6.483h-1.288a.216.216 0 0 0-.217.199 2.574 2.574 0 0 1-5.132 0 .216.216 0 0 0-.217-.198H8.054a.214.214 0 0 0-.215.224 4.296 4.296 0 0 0 4.286 4.061 4.296 4.296 0 0 0 4.286-4.06.214.214 0 0 0-.215-.226"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "defaultAvatar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.125 0h24v24h-24z"
  })))));
};
export default SvgDefaultAvatar;